import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Organisation } from '../../models/organisation';
import { Observable } from 'rxjs';
import { WhitelabelOrganisationInformationModel } from 'src/app/models/whitelabel-organisation-information.model';
import { WhiteLabel } from 'src/app/models/whiteLabel';
import { WhitelabelInformationModel } from 'src/app/models/whitelabel-information.model';

@Injectable({
  providedIn: 'root'
})

export class IdentityWhitelabelApiClient {

  constructor(private http: HttpClient) { }

  getWhitelabel(whitelabelGuid: string) : Observable<WhiteLabel> {
    return this.http.get<WhiteLabel>(environment.identityUrl + "/api/whitelabel/" + whitelabelGuid);
  }

  getOrganisations(whiteLabelId: string) {
    return this.http.get(environment.identityUrl + "/api/whitelabel/" + whiteLabelId + "/organisations");
  }

  getFilteredOrganisation(search: string) {
    return this.http.get<WhitelabelOrganisationInformationModel[]>(environment.identityUrl + "/api/whitelabel/filterOrganisations/" + search);
  }

  getSigningsData(whitelabelGuid: string): Observable<any[]> {
    return this.http.get<any[]>(environment.identityUrl + "/api/whitelabel/" + whitelabelGuid + "/getSigningsByWeeknr");
  }

  async getAzureblobstorage(whiteLabelGuid: string) {
    return this.http.get(environment.identityUrl + "/api/whitelabel/" + whiteLabelGuid + "/azureblobstorage");
  }

  async postAzureblobstorage(whiteLabelGuid: string, body: any) {
    return this.http.post(environment.identityUrl + "/api/whitelabel/" + whiteLabelGuid + "/azureblobstorage", body);
  }

  async addWhiteLabelProvider(whiteLabel: WhiteLabel) {
    return this.http.post(environment.identityUrl + "/api/whitelabel", whiteLabel);
  }
  
  async updateWhiteLabelProvider(whiteLabelGuid: string, whiteLabel: WhiteLabel) {
    return this.http.put(environment.identityUrl + "/api/whitelabel/" + whiteLabelGuid, whiteLabel);
  }

  async deleteWhiteLabel(whiteLabelGuid: string) {
    return this.http.delete(environment.identityUrl + "/api/whitelabel/" + whiteLabelGuid);
  }
}
